/// <reference path="../../../.tmp/typings/tsd.d.ts" />
/// <reference path="../../privatemocks/typings.d.ts" />
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PasswordPrompt;
function PasswordPrompt() {
    return {
        template: require('./passwordprompt.html'),
        restrict: 'E',
        require: ['hmyPasswordPrompt', '^^hmyModal'],
        controller: PasswordPromptController,
        controllerAs: 'vm',
        link: function (scope, element, attrs, _a) {
            var vm = _a[0], modalCtrl = _a[1];
            modalCtrl.decorateChild(vm);
            modalCtrl.resolveReadyPromise(vm);
            vm.configure();
        }
    };
}
var PasswordPromptController = (function () {
    function PasswordPromptController($log, $element, apiError, $q) {
        this.$log = $log;
        this.$element = $element;
        this.apiError = apiError;
        this.$q = $q;
        this.password = '';
        this.isSubmitting = false;
        this.onCancelDeferrable = $q.defer();
        this.onSuccessDeferrable = $q.defer();
        this.onErrorDeferrable = $q.defer();
    }
    /**
     * This method should be overridden by the caller.
     * It should use the password that was captured and return a promise that is either resolved, rejected with an error
     * with type apiError.PASSWORD_REQUIRED_ERROR if the password was not correct which can be handled, or reject
     * otherwise.
     */
    PasswordPromptController.prototype.saveWithPassword = function (currentPassword) {
        this.$log.error('PasswordPromptController.saveWithPassword should be overriden by the caller');
        return this.$q.reject();
    };
    PasswordPromptController.prototype.onSuccess = function (callback) {
        return this.onSuccessDeferrable.promise.then(callback);
    };
    PasswordPromptController.prototype.onError = function (callback) {
        return this.onErrorDeferrable.promise.then(callback);
    };
    PasswordPromptController.prototype.onCancel = function (callback) {
        return this.onCancelDeferrable.promise.then(callback);
    };
    PasswordPromptController.prototype.save = function (form) {
        var _this = this;
        if (form.$valid) {
            this.isSubmitting = true;
            this.saveWithPassword(this.password)
                .then(function (result) { return _this.closeAndResolveWithSuccess(result); })
                .catch(function (error) { return _this.showValidationErrorWhenPasswordRequired(error, form); })
                .finally(function () {
                _this.isSubmitting = false;
            });
        }
    };
    PasswordPromptController.prototype.closeAndResolveWithSuccess = function (result) {
        this.onSuccessDeferrable.resolve(result);
        this.close();
    };
    PasswordPromptController.prototype.showValidationErrorWhenPasswordRequired = function (error, form) {
        if (error.type !== this.apiError.PASSWORD_REQUIRED_ERROR) {
            this.onErrorDeferrable.resolve(error);
            this.close();
        }
        else {
            form.passwordField.password.$setValidity('passwordCorrect', false);
        }
    };
    PasswordPromptController.prototype.cancel = function () {
        this.onCancelDeferrable.resolve(this);
        this.close();
    };
    PasswordPromptController.prototype.passwordChanged = function (form) {
        form.passwordField.password.$setValidity('passwordCorrect', true);
    };
    PasswordPromptController.prototype.configure = function () {
        this.setDismissable(false);
    };
    return PasswordPromptController;
}());
PasswordPromptController.$inject = ['$log', '$element', 'apiError', '$q'];



//////////////////
// WEBPACK FOOTER
// ./src/components/passwordprompt/passwordprompt.directive.ts
// module id = 9
// module chunks = 0